module.exports = __webpack_public_path__ + "img/general-henry-huidekoper.366deadd.png";